// Deterministic swatch picker. Hashes the entity name/id into one of the
// `--ws-a-*` palette colours so the admin view never references a specific
// agent slug (prospecting / forecasting / post-meeting) by name.

const PALETTE = [
	'var(--ws-a-prospecting)',
	'var(--ws-a-forecasting)',
	'var(--ws-a-postmeeting)',
	'var(--ws-a-alex)',
	'var(--ws-a-human)'
];

function hash(input: string): number {
	let h = 0;
	for (let i = 0; i < input.length; i++) {
		h = (h * 31 + input.charCodeAt(i)) | 0;
	}
	return Math.abs(h);
}

export function getInitial(name: string | null | undefined): string {
	if (!name) return '?';
	const trimmed = name.trim();
	if (!trimmed) return '?';
	const parts = trimmed.split(/\s+/);
	if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
	return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

export function getSwatch(seed: string | number | null | undefined): string {
	if (seed === null || seed === undefined) return PALETTE[0];
	const key = typeof seed === 'number' ? `n:${seed}` : seed;
	return PALETTE[hash(key) % PALETTE.length];
}
